import Gallery from "react-photo-gallery";
import projects from "../COMPONENTS/projects/registry";
import LogoCorner from "../COMPONENTS/logoCorners/logoCorner";
import Footer from "../COMPONENTS/Footer/footer";

export const ProjectPageView = ({ setIndex, setUpdate, handleOnClick }) => {
  const photos = projects.map((p) => p.photo);
  return (
    <div>
      <div className="landingPage">
        <LogoCorner text="Sebastian Granlund" onClick={handleOnClick} />
        <h1 className="title">Projects</h1>
        <div id="gallery">
          <Gallery
            photos={photos}
            onClick={(e, { index }) => (setIndex(index), setUpdate(true))}
          />
        </div>
        <Footer />
      </div>
    </div>
  );
};
